import { useIsOverflow } from "@app/shared/qes-standards/utility/useIsOverflow";
import TooltipWrapper from "@app/shared/TooltipWrapper";
import { FC, useRef, useState } from "react";

interface ProjectTypeProps {
  className: string;
  projectType: string;
}

export const ProjectType: FC<ProjectTypeProps> = (props: ProjectTypeProps) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const [isOverflow, setIsOverflow] = useState(false);

  useIsOverflow(ref, (is: boolean) => setIsOverflow(is));

  return (
    <p className={`project-tile__project-type ${props.className}__project-type`} ref={ref}>
      <TooltipWrapper text={isOverflow ? props.projectType : ""}>
        <span>{props.projectType}</span>
      </TooltipWrapper>
    </p>
  )
}